import { ReactNode, type ReactElement } from "react";

const WELCOME_MESSAGES = [
  'Здравствуйте! Я ИИ-ассистент Билдокс. Помогу вам оформить титульный лист быстро и без ошибок. Начнём?',
  'Добрый день, я ваш ИИ-помощник. Я здесь, чтобы помочь заполнить титульный лист, готовы приступить?',
  'Приветствую! Я ИИ-ассистент Билдокс, и моя задача — помочь вам правильно оформить титульный лист. Поехали?',
  'Здравствуйте! Меня зовут Билдокс. Я помогу вам шаг за шагом заполнить титульный лист. Приступим?',
  'Добрый день! Я ИИ-агент Билдокс. Помогу вам заполнить титульный лист аккуратно и без сложностей. Начнём?',
];

export interface ChatMessage {
  id: string;
  statusIcon?: "rejected" | "warning";
  badge?: {
    text: string;
    color: "yellow" | "green" | "red" | "blue" | "gray";
  };
  title?: ReactNode;
  description?: ReactNode;
  typing?: boolean;
  commentLabel?: ReactNode;
  commentText?: ReactNode;
  personCard?: {
    label: string;
    name: string;
    description?: string;
  };
  errors?: Array<{
    id: number;
    description: string | ReactElement;
    sectionId?: string;
    buttonLabel?: string;
  }>;
  errorMessage?: string;
}

export interface ChatAction {
  id: string;
  label: string;
  onClick?: () => void;
  variant?: "primary" | "secondary";
  disabled?: boolean;
}

export interface ChatContextData {
  messages: ChatMessage[];
  actions: ChatAction[];
}

const getRandomMessage = (): string => {
  return WELCOME_MESSAGES[Math.floor(Math.random() * WELCOME_MESSAGES.length)];
};

export const getChatContext = (
  hasStartedFilling: boolean,
  firstEmptySection: string,
  openSections?: (sectionIds: Array<string>) => void,
): ChatContextData => {
  // Первый вход - показываем приветствие
  if (!hasStartedFilling) {
    return {
      messages: [
        {
          id: 'welcome',
          title: getRandomMessage(),
        },
      ],
      actions: [
        {
          id: 'start-fill',
          label: 'Да, начнём',
          onClick: () => {
            if (openSections) {
              openSections([firstEmptySection]);
              setTimeout(() => {
                const element = document.getElementById(firstEmptySection);
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }, 100);
            }
          },
        },
      ],
    };
  }

  // Fallback - для случаев которые обработаны в use-chat-context
  return {
    messages: [
      {
        id: 'default',
        title: 'Продолжайте заполнение титульного листа',
      },
    ],
    actions: [],
  };
};
